import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { logger } from '../utils/logger';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

let cachedNav = null;
let cacheTimestamp = 0;
const CACHE_TTL = 120_000;

export const useNavMenu = () => {
  const [nav, setNav] = useState(cachedNav || null);
  const [loading, setLoading] = useState(!cachedNav);

  const fetchNav = useCallback(async (force = false) => {
    const now = Date.now();
    if (!force && cachedNav && now - cacheTimestamp < CACHE_TTL) {
      setNav(cachedNav);
      setLoading(false);
      return;
    }
    try {
      const res = await axios.get(`${API}/nav-data`);
      cachedNav = res.data;
      cacheTimestamp = Date.now();
      setNav(res.data);
    } catch (error) {
      logger.error('Failed to fetch nav data:', error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchNav(); }, [fetchNav]);

  return { nav, loading, refetch: () => fetchNav(true) };
};
